import { ReactNode } from 'react';

import { LeftBorderContainer } from '../../../../../components/containers/LeftBorderContainer';

type OrganizationMethodCardProps = {
  title: string;
  description?: string;
  count?: string;
  button?: ReactNode;
};

export const OrganizationMethodCard = ({
  title,
  description,
  count,
  button
}: OrganizationMethodCardProps) => {
  return (
    <>
      <LeftBorderContainer className="md:tw-w-[100%] 2xl:tw-w-[50%] tw-shadow-xl">
        <div className="tw-flex tw-flex-col tw-gap-1 tw-text-center tw-my-[20px]">
          <div>
            <p className="tw-font-bold tw-text-[1.25rem]">{title}</p>

            {description ? (
              <p className="tw-min-h-[48px]">{description}</p>
            ) : null}
          </div>

          {count ? (
            <p className="tw-text-[#146CFA] tw-font-bold tw-text-5xl">
              {count}
            </p>
          ) : null}
        </div>

        {button ? button : null}
      </LeftBorderContainer>
    </>
  );
};
